<h1 id="2500-8-signature-heading" class="flex-align-center grid-gap-1"><fa-icon [icon]="faFileLines" aria-label="2500-8-signature"></fa-icon>
<span class="font-sans-lg text-bold line-height-sans-1 margin-top-0 margin-bottom-1">2500-8 REPORTS - NEEDS SIGNATURE ({{report_count}})</span>
</h1>
<table mat-table [dataSource]="reports" class="center" multiTemplateDataRows
  aria-labelledby="2500-8-signature-heading 2500-8-signature-caption">
  <caption id="2500-8-signature-caption" class="usa-sr-only">
    2500-8 Reports - Needs Signature. Columns: 2500-8 Reports, Report ID, Action Type, Report Type, Report Status,
    Authorization Status, Action.
  </caption>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>2500-8 Reports</th>
    <td mat-cell *matCellDef="let report"><a [routerLink]="'/report-overview'"
    [queryParams]="{report_id: report.report_id}">{{report.assessment.baer_name}}({{report.report_num}})</a>
  </td>
</ng-container>
<ng-container matColumnDef="reportId">
  <th mat-header-cell *matHeaderCellDef>Report ID</th>
  <td mat-cell *matCellDef="let report" class="prewrap">{{report.report_id}}</td>
</ng-container>
<ng-container matColumnDef="action_type">
  <th mat-header-cell *matHeaderCellDef>Action Type</th>
  <td mat-cell *matCellDef="let report" class="prewrap">
    @if(report.report_num == 0) {
      Pre-Assessment
    } @else if(report.report_num == 1) {
      Initial
    } @else {
      Interim
    }
  </td>
</ng-container>
<ng-container matColumnDef="report_type">
  <th mat-header-cell *matHeaderCellDef>Report Type</th>
  <td mat-cell *matCellDef="let report" class="prewrap">
    @switch (report.report_type) {
      @case ('Emergency Stabilization') {
        Funding Request
      }
      @default {
        {{report.report_type}}
      }
    }
  </td>
</ng-container>
<ng-container matColumnDef="report_status">
  <th mat-header-cell *matHeaderCellDef>Report Status</th>
  <td mat-cell *matCellDef="let report" class="prewrap">
    <mat-chip [ngClass]="'chip-4'">
      {{4 | statusBadge}}
    </mat-chip>
  </td>
</ng-container>
<ng-container matColumnDef="auth_status">
  <th mat-header-cell *matHeaderCellDef>Authorization Status</th>
  <td mat-cell *matCellDef="let report" class="prewrap">
    @if (report.authorization_status_id != null) {
      <mat-chip
        [ngClass]="'chip-a-'+report?.authorization_status_id">
        {{report.authorization_status_id | authorizationStatusBadge}}
      </mat-chip>
    }
    @if (report.authorization_status_id == null) {
      <span>--</span>
    }
  </td>
</ng-container>
<ng-container matColumnDef="comments">
  <td class="empty-header" mat-header-cell *matHeaderCellDef></td>
  <td mat-cell *matCellDef="let report" class="prewrap">
    <div class="icon-message">
      @if(report.comments_unresolved) {
        <fa-icon [icon]="faMessage" class="chat-count-red" aria-label="chat"></fa-icon><span class="button-text chat-text-red"
        matTooltip='The report has comments that need to be revised and completed before submission.'
        matTooltipClass="tooltipClass">{{report.comments?.length ??
      0}}</span>
    } @else {
      <fa-icon [icon]="faMessage" class="chat-count" aria-label="chat"></fa-icon><span class="button-text chat-text"
      matTooltip='There are no open comments on the report.'
    matTooltipClass="tooltipClass">{{report.comments?.length ?? 0}}</span>
  }
</div>
</td>
</ng-container>
<ng-container matColumnDef="action">
  <th mat-header-cell *matHeaderCellDef style="width: 270px;">Action</th>
  <td mat-cell *matCellDef="let report" style="width: 270px;">
    <div class="action-div">
      <button class="btn-only" [routerLink]="'/report-overview'"
        [queryParams]="{report_id: report.report_id}">
        <mat-icon>visibility</mat-icon>View 2500-8 Report
      </button>
    </div>
  </td>
</ng-container>

<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
<tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"></tr>

<!-- Row shown when there is no matching data. -->
<tr class="mat-row" *matNoDataRow>
  <td class="mat-cell" colspan="13">
    <div class="no-data">
      <div class="no-data-icon">
        <mat-icon class="no-data-icon1">search</mat-icon>
        <fa-icon [icon]="faFire" class="no-data-icon2"></fa-icon>
      </div>
      <div class="no-data-title">No Reports</div>
      <p>There are no reports to sign off on at this time</p>
    </div>
  </td>
</tr>
</table>

@if (this.reports.data?.length != this.rawReports?.length) {
  <button aria-label="View All" class="usa-button usa-button--secondary view-all"
    (click)="loadMore()">Load More<fa-icon
  [icon]="faChevronRight" aria-label="View All"></fa-icon></button>
}
